import{a as i}from"./chunk.2AIXLGYE.js";import{a as e}from"./chunk.XPINZPW5.js";import{a as r}from"./chunk.65JZXZ5X.js";import{c as o}from"./chunk.NWIV65VP.js";import{property as n}from"lit/decorators.js";import{css as s}from"lit";var a=s`
  ${i}

  :host {
    display: block;
    box-sizing: content-box;
    height: 0;
    margin: var(--he-spacing-2x-small) 0;
    border: none;
    border-top: var(--he-form-control-border-width) solid var(--he-color-body-divider);
  }

  :host([orientation='vertical']) {
    height: 100%;
    margin: 0 var(--he-spacing-2x-small);
    border: none;
    border-left: var(--he-form-control-border-width) solid var(--he-color-body-divider);
  }
`;var t=class extends r{constructor(){super(...arguments);this.presentation=!1;this.orientation="horizontal"}syncAttributes(){this.presentation?(this.setAttribute("role","presentation"),this.removeAttribute("aria-orientation")):(this.setAttribute("role","separator"),this.setAttribute("aria-orientation",this.orientation))}};t.styles=a,t.baseName="divider",t.reactEvents={},o([n({type:Boolean,reflect:!0})],t.prototype,"presentation",2),o([n({reflect:!0})],t.prototype,"orientation",2),o([e("orientation"),e("presentation")],t.prototype,"syncAttributes",1);var y=t;export{t as a,y as b};
